import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';

@Injectable({
  providedIn: 'root'
})
export class IsIn2FAVerificationGuard  {

  constructor(private router: Router) {}

  canActivate(): boolean {
    const tempToken = localStorage.getItem('temp2FAToken');

    if (!tempToken) {
      this.router.navigateByUrl('/login');
      return false;
    }

    const jwtHelper = new JwtHelperService();

    try {
      const decoded = jwtHelper.decodeToken(tempToken);

      if (decoded?.is_2fa_temp === true && !jwtHelper.isTokenExpired(tempToken)) {
        return true;
      }
    } catch (e) {
      console.log(e);
    }

    this.router.navigateByUrl('/login');
    return false;
  }
}
